import { IconChevronLeft } from '@tabler/icons-react'
import { Dayjs } from 'dayjs'
import { Children, ReactNode } from 'react'

import { AstraButton, AstraEmpty, AstraIcon, AstraParagraph, DATE_TEMPLATES, format, Spinner } from '~/astra'

type Props = {
    date: Dayjs
    onClose: () => void
    isLoading: boolean
    afterTitle?: ReactNode
    children?: ReactNode
}

export const BaseActivityLog = ({ date, onClose, isLoading, afterTitle, children }: Props) => (
    <div className="flex flex-col items-stretch">
        <div className="flex w-full items-center justify-between gap-8 border-b py-3 pr-3">
            <div className="flex items-center space-x-2">
                <AstraButton aria-label="Tilbake" variant="ghost" onClick={onClose} icon={<AstraIcon icon={IconChevronLeft} />} />
                <AstraParagraph weight="medium" variant="body">
                    Aktivitetslogg {format(date, DATE_TEMPLATES.longMonth)}
                </AstraParagraph>
            </div>
            {afterTitle}
        </div>

        {isLoading ? (
            <div className="flex flex-col items-center gap-4 py-8" role="status">
                <Spinner size="md" />
                <AstraParagraph>Laster aktivitetslogg...</AstraParagraph>
            </div>
        ) : Children.count(children) === 0 ? (
            <div className="p-4" role="status">
                <AstraEmpty text="Ingen aktiviteter enda" size="small" />
            </div>
        ) : (
            <div className="relative my-4">
                <div className="max-h-96 overflow-y-auto px-4 pb-2">
                    <div className="relative">
                        {/* color is hardcoded because we want border-medium-rest but have to use background for technical reasons */}
                        <div className="pointer-events-none absolute bottom-0 left-8 top-0 w-[2px] bg-[#e0e1e6]" />
                        <div className="relative z-priority flex flex-col items-stretch gap-6">{children}</div>
                    </div>
                </div>
            </div>
        )}
    </div>
)
